import React, { Component } from "react";
import cx from "classnames";
import firebase, { createVideo } from "../sdks/firebase";
import Clipboard from "clipboard/lib/clipboard.js";

import Player from "./Player.js";
import ytSDK from "../sdks/YtSDK.js";
import GetChromeExtension from "./GetChromeExtension.js";
import Logo from "./Logo.js";

class PageVideo extends Component {
  constructor(props) {
    super();
    this.state = {
      firebase: null,
      yt: {
        video: null,
        channel: null,
      },
      displayInfos: false,
      linkCopied: false,
    };

    this.database = firebase.database();
    let { id, start, end } = props.params;

    this.firebaseID = (id + start + end).split(".").join("-");
    this.videosRef = this.database.ref(`videos`);
    this.videoRef = this.videosRef.child(this.firebaseID);
  }

  componentWillMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        firebase
          .auth()
          .signInAnonymously()
          .catch(error => console.error(error));
      } else {
        this.user = user;
        this.getFirebaseData();
        this.fetchVideoData();
      }
    });
  }

  componentWillUnmount() {
    this.videoRef.off("value", this.handleVideoSnapshot);
  }

  async fetchVideoData() {
    // fetch video data
    const data = await ytSDK.getVideoInfos(this.props.params.id);
    this.setMetas(data.video);

    // settings this.state video & channel
    this.setState({
      yt: data,
    });

    setTimeout(() => {
      this.setState({ displayInfos: true });
    }, 2000);
  }

  getFirebaseData() {
    if (this.state.firebase) {
      return;
    }

    this.videoRef.once("value", snap => {
      // create video if does not exist yet
      if (!snap.val()) {
        const { id, start, end } = this.props.params;
        createVideo(this.firebaseID, id, start, end, this.user);
      }

      this.incrementViews();

      this.videoRef.on("value", this.handleVideoSnapshot);
    });
  }

  handleVideoSnapshot = snap => {
    const data = snap.val();

    if (!data) {
      return;
    }

    const {
      infos,
      views: { count },
    } = data;

    this.setState({
      firebase: {
        infos,
        views: { count },
      },
    });
  };

  hasNotViewedYet() {
    return new Promise((resolve, reject) => {
      this.videoRef
        .child(`views/users/${this.user.uid}`)
        .once("value", snapshot => {
          if (!snapshot.val()) resolve();
        });
    });
  }

  incrementViews() {
    // if not, increment count
    this.videoRef.child("views/count").transaction(
      count => {
        return count !== null ? count + 1 : count;
      },
      () => {
        // and add user to views/users
        // this.videoRef.child("views/users").child(this.user.uid).set(true);
      }
    );
  }

  /*
  async updateViews() {
    const hasNotViewedYet = await this.hasNotViewedYet();
    if (hasNotViewedYet) {
      this.incrementViews();
    }

    let watchingRef = this.videoRef.child(`watching/${this.user.uid}`);
    watchingRef.once("value", snap => {
      if (!snap.val()) {
        watchingRef.set(true);
        watchingRef.onDisconnect().remove();
      }
    });
  }
  */

  setClipboard = el => {
    if (!el) {
      return;
    }
    let clipboard = new Clipboard(el);
    clipboard.on("success", e => {
      this.setState({ linkCopied: true });
      setTimeout(() => {
        this.setState({ linkCopied: false });
      }, 1500);
    });
  };

  setMetas(video) {
    let { id } = this.props.params;

    // https://developers.facebook.com/docs/sharing/webmasters
    let metas = [
      // { property: "fb:app_id", content:  }, // TODO
      { property: "og:type", content: "video" },
      { property: "og:url", content: document.location.href },
      { property: "og:title", content: video.snippet.title },
      { property: "og:description", content: video.snippet.description },
      { property: "og:site_name", content: "waat.tv" },
      { property: "og:image", content: video.snippet.thumbnails.medium.url },

      {
        property: "og:video:url",
        content: `https://www.youtube.com/embed/${id}`,
      },
      {
        property: "og:video:secure_url",
        content: `https://www.youtube.com/embed/${id}`,
      },
      { property: "og:video:type", content: "text/html" },
      { property: "og:video:width", content: "1280" },
      { property: "og:video:height", content: "720" },

      {
        property: "og:video:url",
        content: `http://www.youtube.com/v/${id}?version=3&amp;autohide=1`,
      },
      {
        property: "og:video:secure_url",
        content: `https://www.youtube.com/v/${id}?version=3&amp;autohide=1`,
      },
      { property: "og:video:type", content: "application/x-shockwave-flash" },
      { property: "og:video:width", content: "1280" },
      { property: "og:video:height", content: "720" },
    ];

    metas.forEach(data => {
      let meta = document.createElement("meta");
      meta.setAttribute("property", data.property);
      meta.content = data.content;
      document.getElementsByTagName("head")[0].appendChild(meta);
    });
  }

  renderInfos() {
    let { yt, displayInfos, linkCopied, firebase } = this.state;
    let { video, channel } = yt;
    let { start } = this.props.params;

    if (!video || !channel || !firebase) {
      return null;
    }

    let copyLinkClasses = [];
    if (linkCopied)
      copyLinkClasses.push("hint--bottom", "hint--always", "hint--rounded");

    const {
      views: { count },
    } = firebase;
    const watching = 0;

    let minutes = Math.floor(start / 60),
      seconds = start - minutes * 60,
      fullVideoLink = `//www.youtube.com/watch?v=${this.props.params.id}&t=${minutes}m${seconds}s`;

    return (
      <div
        className={cx("video__infos", {
          "video__infos--displayed": displayInfos,
        })}
      >
        <div className="video__infos__top">
          <div className="video__infos__left">
            <img
              className="video__infos__avatar"
              alt={channel.snippet.title}
              src={channel.snippet.thumbnails.default.url}
            />
            <div className="video__infos__title ">
              <h1>{video.snippet.title}</h1>
              <p>{channel.snippet.title}</p>
            </div>
          </div>

          <div className="video__infos__right">
            <p>
              <span>{count}</span> {count > 1 ? "views" : "view"}
            </p>
            {/* <p className="video__watching">
              <span>{watching}</span> watching
            </p> */}
          </div>
        </div>

        <div className="video__infos__btns">
          <a
            href=""
            onClick={e => e.preventDefault()}
            ref={this.setClipboard}
            // className={"btn btn--red " + copyLinkClasses.join(" ")}
            className={cx("btn", "btn--red", {
              "hint--bottom hint--always hint--rounded": linkCopied,
            })}
            data-clipboard-text={window.location.href}
            aria-label="Link copied!"
          >
            Copy link
          </a>
          <a href={fullVideoLink} target="_blank" className={"btn btn--green"}>
            See full video
          </a>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="page-video">
        <header>
          <Logo />
          <GetChromeExtension />
        </header>
        <div className="video">
          <Player {...this.props} />
          {this.renderInfos()}
        </div>
      </div>
    );
  }
}

export default PageVideo;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/PageVideo.js
 **/